module.exports = __webpack_public_path__ + "img/cooperate_14.25bfa12a.png";